import Vue from 'vue'

Vue.directive('aimSort', {
  bind (el, binding, vnode) {
    // if(!binding.targetArray || binding.)
    el.addEventListener('click', function (event) {
    })
  }
})
